import SelfPayFormDependent from './selfPayFormDependent';
import SelfPayFormSpouse from './selfPayFormSpouse';
import { find, filter, map, cloneDeep } from 'lodash';
import SelfPayFormSubscriber from './selfPayFormSubscriber';
import SelfPayOrigin from './selfPayOrigin';
import Plan from './plan';
import { SelfpayFormComponent } from '../modules/adminHCA/components/selfpay/reviewGrid/components/reviewForm/selfpay.form.component';
import { env } from 'src/env/development';

export default class SelfPayForm {
  requestedChanges = {
    'Add Dependents': false,
    'Remove Dependents': false,
    'Change Medical Plan': false,
    'Change Dental Plan': false,
    'Enroll After Waiving Medical': false,
    'Waive Medical Due to enrollment in other employer-based group medical, a TRICARE plan, or Medicare': false
  };
  paymentOptions = {
    pensionDeduction: false,
    automaticWithdrawl: false,
    checkOrMoneyOrder: false,
    defferedEnrollment: false
  };
  ltdPlanName: string;
  subscriber: SelfPayFormSubscriber;
  subscriberMedicalCovered: boolean;
  subscriberDentalCovered: boolean;
  subscriberTobaccoUseInd: boolean;
  selfPayReason: string;
  dateOfService: Date;
  spouse: SelfPayFormSpouse;
  dependents: SelfPayFormDependent[];
  origin?: SelfPayOrigin;
  medicalPlan: Plan;
  medicalPlans: Plan[];
  dentalPlan: Plan;
  visionPlan: Plan;
  continueCurrentSelectedVision = false;
  continueCurrentSelectedDental = false;
  continueCurrentSelectedMedical = false;
  continueCurrentPaymentOption = false;
  mailingAddressSameAsResidential: boolean;
  deferPaymentOption: boolean = false;
  ethnicityDependent: SelfPayFormDependent;
  ethnicitySpouse: SelfPayFormDependent;

  constructor(selfPayForm?) {      
      this.requestedChanges = selfPayForm?.requestedChanges ? selfPayForm.requestedChanges : {
        'Add Dependents': false,
        'Remove Dependents': false,
        'Change Medical Plan': false,
        'Change Dental Plan': false,
        'Enroll After Waiving Medical': false,
        'Waive Medical Due to enrollment in other employer-based group medical, a TRICARE plan, or Medicare': false
      };
      this.paymentOptions = selfPayForm?.paymentOptions ? selfPayForm.paymentOptions : {
        pensionDeduction: false,
        automaticWithdrawl: false,
        checkOrMoneyOrder: false,
        defferedEnrollment: false
      };
      this.subscriber = selfPayForm?.subscriber ? new SelfPayFormSubscriber(selfPayForm?.subscriber) : new SelfPayFormSubscriber();
      this.subscriberMedicalCovered = selfPayForm?.subscriberMedicalCovered;
      this.subscriberDentalCovered = selfPayForm?.subscriberDentalCovered;
      this.subscriberTobaccoUseInd = selfPayForm?.subscriberDentalCovered;
      this.spouse = selfPayForm?.spouse ? new SelfPayFormSpouse(selfPayForm.spouse) : new SelfPayFormSpouse({});
      this.dependents = selfPayForm?.dependents ? map(selfPayForm?.dependents, (d) => {
        const dep = new SelfPayFormDependent(d);
        dep.applyDefaults(selfPayForm, this.subscriber);
        return dep;
      }) : null;
      this.selfPayReason = selfPayForm?.selfPayReason;
      this.dateOfService = selfPayForm?.dateOfService ? new Date(selfPayForm?.dateOfService) : null;
      this.origin = selfPayForm?.orgin ? new SelfPayOrigin(selfPayForm.orgin) : null;
      this.ltdPlanName = selfPayForm?.ltdPlanName;
      this.medicalPlan = selfPayForm?.medicalPlan || new Plan();
      this.dentalPlan = selfPayForm?.dentalPlan || new Plan();
      this.visionPlan = selfPayForm?.visionPlan || new Plan();
      this.medicalPlans = selfPayForm?.medicalPlans || [];
      this.mailingAddressSameAsResidential = selfPayForm?.mailingAddressSameAsResidential;
      this.deferPaymentOption = selfPayForm?.deferPaymentOption;
      this.continueCurrentSelectedVision = selfPayForm?.continueCurrentSelectedVision;
      this.continueCurrentSelectedDental = selfPayForm?.continueCurrentSelectedDental;
      this.continueCurrentSelectedMedical = selfPayForm?.continueCurrentSelectedMedical;
      this.continueCurrentPaymentOption = selfPayForm?.continueCurrentPaymentOption;
  }

  setEthnicityDependents() {
    if (this.dependents[0]) {
        this.ethnicitySpouse = find(this.dependents,(dep:SelfPayFormDependent)=> dep.relationshipTypeName === env.spouseRelationshipTypeName);
        var existingEthnicityDep = find(this.dependents,(dep:SelfPayFormDependent)=> dep.ethnicityDependent );
        if (existingEthnicityDep) {
          this.ethnicityDependent = existingEthnicityDep;
        } else {
          var deps = filter(this.dependents,(dep:SelfPayFormDependent)=> dep.relationshipTypeName !== env.spouseRelationshipTypeName);
          if (deps.length>0) {
            deps[0].ethnicityDependent = true;
            this.ethnicityDependent = deps[0];
          }
        }
      }
  }
}

